export default __webpack_public_path__ + "static/media/position.cd94c302.svg";